import { Injectable } from '@angular/core';
import { ProjectStatus } from '../models/project';
import { ObjectStatus } from '../models/object';

@Injectable()
export class OptionService {

  constructor() {
  }

  get projectStatusOptions() {
    let names = this.projectStatusNames;

    return Object.keys(names).map(k => {
      return {
        value: k,
        label: names[k]
      };
    });
  }

  get projectStatusNames() {
    let options = [];

    options[ProjectStatus.Active] = 'Pågående';
    options[ProjectStatus.Upcoming] = 'Kommande';
    options[ProjectStatus.Archived] = 'Avslutat';

    return options;
  }

  get objectStatusOptions() {
    let names = this.objectStatusNames;

    return Object.keys(names).map(k => {
      return {
        value: k,
        label: names[k]
      };
    });
  }

  get objectStatusNames() {
    let options = [];

    options[ObjectStatus.ForSale] = 'Till salu';
    options[ObjectStatus.Booked] = 'Bokad';
    options[ObjectStatus.Removed] = 'Borttagen';
    options[ObjectStatus.Reserved] = 'Reserverad';
    options[ObjectStatus.Sold] = 'Såld';
    options[ObjectStatus.Display] = 'Visningslägenhet';

    return options;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/option.service.ts